module.exports = __webpack_public_path__ + "static/template_cozy_v2-b8cccb5d625c7cced5e3a2bceedfc5a8.png";